export default __webpack_public_path__ + "static/media/flag-panama.40ca98f6.svg";